<template>
  <el-dialog
    :title="userName +'拒单列表'"
    :visible.sync="refuseIsShow"
    width="635px"
    append-to-body
  >
    <el-table :data="refuseJobList" v-loading="listLoading"  
    stripe 
    :header-cell-style="{background:'#F5F7FA'}">
      <el-table-column
        property="JobNo"
        label="工单编号"
        width="120"
      ></el-table-column>
      <el-table-column
        property="RealName"
        label="操作人"
        show-overflow-tooltip
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.RealName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        property="CreateTime"
        label="操作时间"
        width="150"
      ></el-table-column>
      <el-table-column
        property="Reason"
        show-overflow-tooltip
        label="拒绝理由"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.Reason || "--" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="refuseJobList.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listCount"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getRefuseJobList, // 获取拒单列表
} from "@/service/job";
export default {
  props: {
    userName: {
      type: String,
    },
  },
  data() {
    return {
      refuseIsShow: false,
      listLoading: false,

      refuseJobList: [],
      listCount: 0,
      userId: 0,
      companyId: 0,
      jobId:0,
      pageNum: 1,
      pageSize: 10,
    };
  },
  methods: {
    openDia(row) {
      this.refuseIsShow = true;

      if (row.UserId) {
      this.userId = row.UserId;
      this.companyId =0;
      }
      else if (row.CompanyId) {
        this.companyId = row.CompanyId;
        this.userId = 0;
      }
      console.log("openDia userId:" + this.userId + " companyId:" + this.companyId);

      if (row.JobId) this.jobId = row.JobId;
    },

    handleSizeChange(val) {
      if (this.listLoading) return;
      this.pageNum = 1;
      this.pageSize = val;
      this.loadList();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      console.log(val);
      this.pageNum = val;
      this.loadList();
    },

    async loadList() {
      this.listLoading = true;
      var data = {
        CompanyId: this.companyId,
        UserId: this.userId,
        JobId: this.jobId,
        PageNum: this.pageNum,
        PageSize: this.pageSize,
      };
      console.log(data);

      let res = await getRefuseJobList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }

      console.log(res);
      if (res.Result != 1) {
        return this.$message.error(res.Message);
      }
      //   this.$message({ message: res.Message, type: "success" });

      this.$nextTick(() => {
        this.listCount = res.Data.TotalCount;
        this.refuseJobList = res.Data.JobList;
        console.log("listCount:" + this.listCount);
        console.log("refuseJobList:" + this.refuseJobList);
      });
    },
  },
};
</script>

<style scoped>
</style>